export default class BaseApiResponseModel<T = any> {
  constructor(
    public data?: PaginatedData<T> | RawData<T> | T | T[] | null,
    public message?: string,
    public error?: ApiError,
    public code?: number,
    public detail?: string,
  ) {}
}

export class PaginatedData<T> {
  constructor(
    public items: T[] = [],
    public pagination: Pagination = new Pagination(),
    public success_count?: number,
    public error_count?: number,
    public metadata?: Metadata,
  ) {}
}

export class RawData<T = any> {
  constructor(public raw: T) {}
}

export class Metadata {
  constructor(public count_success: number = 0) {}
}

export class Pagination {
  constructor(
    public page: number = 0,
    public limit: number = 10,
    public total: number = 0,
  ) {}
}

export class ApiError {
  constructor(
    public code?: number,
    public message?: string,
  ) {}
}
